import Session from 'mewe/shared/session';
import { taskAxios } from 'mewe/services/Task';
import FunctionalUtils from 'mewe/shared/functional-utils';

export default {
  async uploadImage(file) {
    let formData = new FormData();
    formData.append('file', file);
    try {
      const promise = await taskAxios({
        url: '/api/v2/photo/uc',
        method: 'POST',
        data: formData,
        headers: {
          'X-CSRF-Token': Session.getCsrfToken(),
          'content-type': 'application/json; charset=UTF-8',
        },
      });
      return promise.data;
    } catch (error) {
      if (error?.response?.data?.errorCode === 700) {
        return error.response.data;
      }
      FunctionalUtils.showDefaultErrorMessage();
    }
  },
};
